// The trial's notice (shared/trial.ts), on every screen for everyone in the office while one is open:
// what they change is thrown away when it ends. The migration banner's slim line, in the warning tone.
import { TRIAL_LINE, useTrial } from '../shared/trial.ts';

export function TrialBanner() {
  const trial = useTrial();
  if (!trial) return null;
  const text =
    trial.state === 'on'
      ? TRIAL_LINE
      : trial.state === 'starting'
        ? 'A trial is starting: the office is unavailable for a minute or two while its snapshot is taken.'
        : 'The trial is ending: its changes are being thrown away and the import resumes shortly.';
  return (
    <div className="mig-banner trial" role="status">
      <p title={text}>{text}</p>
    </div>
  );
}
